export default {
    baseurl: 'https://opapi.jsdnzydlkj.com',
};

